import React, { useEffect, useState } from "react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import "./UngradedGames.css";
import { Divider } from "@material-ui/core";
import InputSelect from "../InputSelect";
import axios from "axios";
import { toast } from "react-toastify";

const useStyles = makeStyles((theme) => ({
  root: {
    width: 10,
    height: 10,
  },
  button: {
    display: "block",
    marginTop: theme.spacing(2),
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  headerCell: {
    textAlign: "center",
  },
  hidden: {
    display: "none",
  }
}));


const UngradedGames = () => {
  const classes = useStyles();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [sports, setSports] = useState();
  const [IdSport, setIdSport] = useState("");
  const [SportChange, setSportChange] = useState(true);
  const [data, setData] = useState([])
  const [userInfo, setUserInfo] = useState(
    JSON.parse(localStorage.getItem("userInfo"))
  );
  const [weekDays, setWeekDays] = useState([]);
  const [selectedDay, setSelectedDay] = useState("-1");

  useEffect(() => {
    setWeekDays(getWeekDays());
  }, []);

  useEffect(() => {
    //Change for server api address
    const url = process.env.REACT_APP_API2_URL + "/League/GetAllSports";
    axios
      .get(url)
      .then((response) => response.data)
      .then((data) => {
        let groupingInfo = data.map((v) => {
          v.IdSport = v.IdSport;
          v.SportName = v.SportName;
          return v;
        });
        if (groupingInfo.length > 0) {
          setIdSport(groupingInfo[0].IdSport);
          setSportChange(false);
          setSportChange(true);
        }
        setSports(groupingInfo);
      });
  }, []);

  useEffect(() => {
    if (IdSport && selectedDay !== "-1") {
      Ungrade_GetGamesList()
    }
  }, [IdSport, selectedDay])

  function getMondayOfCurrentWeek() {
    let now = new Date();
    console.log(now)
    let dayOfWeek = now.getDay();
    let diff = dayOfWeek === 0 ? -6 : 1 - dayOfWeek;
    let monday = new Date(now.setDate(now.getDate() + diff));

    return monday.toISOString().split('T')[0];
  }

  function getMondayOfCurrentWeek2() {
    let now = new Date();
    let dayOfWeek = now.getDay();
    let diff = dayOfWeek === 0 ? -6 : 1 - dayOfWeek;

    let monday = new Date(now);
    monday.setDate(now.getDate() + diff);

    return monday;
  }

  function getWeekDays() {
    let monday = getMondayOfCurrentWeek2();
    let weekDays = [];
    setSelectedDay(getMondayOfCurrentWeek());
    // weekDays.push({
    //   value: "-1",
    //   text: "Select an option"
    // })
    for (let i = 0; i < 7; i++) {
      let day = new Date(monday);
      day.setDate(monday.getDate() + i);

      weekDays.push({
        value: day.toISOString().split("T")[0],
        text: day.toLocaleDateString("en-US", {
          weekday: "long",
          day: "2-digit",
          month: "2-digit",
        }),
      });
    }

    return weekDays;
  }

  function Ungrade_GetGamesList() {
    // let mondayDate = getMondayOfCurrentWeek();

    axios({
      method: "get",
      url: process.env.REACT_APP_API2_URL + "/Game/Ungrade_GetGamesList?idSport=" + IdSport.trim() + "&date=" + selectedDay,
    }).then((response) => {
      setData(response.data)
    });
  }

  function Ungrade_Game(idGame) {

    if (selectedDay === "-1") {
      toast.error("Select a date to continue.");
    }
    axios({
      method: "get",
      url: process.env.REACT_APP_APIGRADE_URL + "/Ungrade/UngradeGame?idGame=" + idGame + "&idUser=" + userInfo.userId,
    }).then((response) => {
      console.log(response);
      if (response.data === 1) {
        toast.success("Game Ungraded Successfully");
        Ungrade_GetGamesList()
      } else {
        toast.error("An error has occurred. Please try again.")
      }
    });
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };



  function changeSportID(value) {
    setIdSport(value);
    setSportChange(false);
    setSportChange(true);
  }

  function changeDay(value) {
    setSelectedDay(value);
  }

  function FormatDate(date) {
    return date.replace("T", " ")
  }

  return (
    <div className="MuiTable-root2">
      <h2>Ungrade Games</h2>
      <Divider className="mt-4 mb-4"></Divider>
      <InputSelect
        size="small"
        classes="w-full lg:w-auto lg:flex-1 mb-4"
        label="Sports"
        variant="outlined"
        name="name"
        data={sports}
        placeholder="Sports"
        setSelectValue={changeSportID}
        startValue={IdSport}
      />
      <InputSelect
        size="small"
        classes="w-full lg:w-auto lg:flex-1 mb-4 ml-3"
        label="Date"
        variant="outlined"
        name="name"
        data={weekDays}
        placeholder="DataFormatter"
        setSelectValue={changeDay}
        startValue={selectedDay}
      />

      {/* <select>
          {weekDays.map((day) => (
            <option key={day.value} value={day.value}>
              {day.label}
            </option>
          ))}
        </select> */}
      <div className="ungraded-cont">
        <Table className="schedule ungraded-table">
          <TableHead className={classes.tableHead}>
            <TableRow>
              <TableCell className={`${classes.hidden} text-center`}>IdGame</TableCell>
              <TableCell className={classes.headerCell}>Game Date</TableCell>
              <TableCell className={classes.headerCell}>Game</TableCell>
              <TableCell className={classes.headerCell}>Score</TableCell>
              {/* <TableCell className={classes.headerCell}>Qty</TableCell> */}
              <TableCell className={classes.headerCell}>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => (
              <TableRow key={row.IdGame}>
                <TableCell className={classes.hidden}>{row.IdGame}</TableCell>
                <TableCell className={classes.headerCell}>{row.GameDateTime.replace("T", " ")}</TableCell>
                <TableCell className={classes.headerCell}>
                  <div>
                    <p>[{row.VisitorNumber}]  {row.VisitorTeam}</p>
                    <p>[{row.HomeNumber}]  {row.HomeTeam}</p>
                  </div>
                </TableCell>
                <TableCell className={classes.headerCell}>
                  <div>
                    <p>{row.VisitorScore}</p>
                    <p>{row.HomeScore}</p>
                  </div>
                </TableCell>
                {/* <TableCell className={classes.headerCell}>{row.Qty}</TableCell> */}
                <TableCell className={classes.headerCell}>
                  <Button variant="contained" color="primary" className="mt-2 mb-2" disabled={!row.Graded} onClick={() => Ungrade_Game(row.IdGame)}>
                    Ungrade
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
      <TablePagination
        rowsPerPageOptions={[50, 100, 200]}
        component="div"
        count={data.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </div>
  );
}

export default UngradedGames
